import { Component, computed, input } from '@angular/core';
import { ProductAttributeOptionInterface } from "@gea-waldviertler-website/gea-models";

@Component({
    selector: 'gea-shop-product-swatch-color',
    templateUrl: './swatch-color.component.html',
    standalone: false
})
export class SwatchColorComponent {

  colorOption = input<ProductAttributeOptionInterface | undefined>(undefined)
  swatchImage = input<string | undefined>(undefined)
  active = input<boolean>(false)

  isColorful = computed(() => {
    const co = this.colorOption()
    if (! co) {
      return true
    }

    return co.title.toLocaleLowerCase() == "bunt"
  })

  // Barrierefreier Textfallback: Auch wenn keine Farbbezeichnung vorliegt,
  // muss das Swatch-Bild/-Symbol einen nicht-leeren Alternativtext haben
  // (WCAG 2.1 AA - 1.1.1 Non-text Content).
  altText = computed(() => this.colorOption()?.title || 'Farbvariante')
}
